import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { usePermissions } from '@/hooks/usePermissions';
import { activeLinkId, visibleSidebar, type SidebarSection } from '@/navigation/sidebarNav';
import { activeWorkspaceId, resolveWorkspaces, type ResolvedWorkspace } from '@/navigation/workspaces';

export interface WorkspaceNav {
  sections: SidebarSection[];
  workspaces: ResolvedWorkspace[];
  active: ResolvedWorkspace | null;
  activeId: string | null;
  currentLinkId: string | null;
}

/** Aree visibili per il ruolo corrente e area della pagina aperta. */
export function useWorkspaces(): WorkspaceNav {
  const { pathname } = useLocation();
  const permissions = usePermissions();

  const sections = useMemo(() => visibleSidebar(permissions), [permissions]);

  const workspaces = useMemo(() => resolveWorkspaces(sections), [sections]);
  const activeId = useMemo(() => activeWorkspaceId(pathname, workspaces), [pathname, workspaces]);
  const active = workspaces.find((workspace) => workspace.id === activeId) ?? null;
  const currentLinkId = useMemo(() => activeLinkId(pathname, sections), [pathname, sections]);

  return { sections, workspaces, active, activeId, currentLinkId };
}
